import api from "../utils/axios";
export async function getFinancialReports() {
  try {
    const res = await api.get(`/auth/financial-report`);
    return res.data;
  } catch (error) {
    console.error("Failed to load the financial report:", error);
    throw error;
  }
}

